"use client";

import { useEffect } from "react";
import { reportError } from "@/lib/reportError";
import { ErrorTriangleOutlineIcon } from "@/components/icons/ErrorTriangleOutlineIcon";

export default function RootError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("[RootError] Unhandled route error:", error);
    reportError(error, { boundary: "app/error" });
  }, [error]);

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-bg-base">
      <div className="max-w-md w-full rounded-20 p-8 text-center bg-bg-elevated border border-solid border-border-default">
        <div className="w-14 h-14 rounded-20 flex items-center justify-center mx-auto mb-5 bg-palette-red/10">
          <ErrorTriangleOutlineIcon className="w-7 h-7 text-palette-red" />
        </div>
        <h1 className="text-5 font-semibold mb-2 text-fg-default">
          Something went wrong
        </h1>
        <p className="text-3.5 mb-5 text-fg-muted">
          An unexpected error occurred. Try again or refresh the page.
        </p>
        {error.message && (
          <div className="rounded-16 p-4 mb-5 text-left bg-palette-red/6 border border-solid border-palette-red/20">
            <p className="text-3 font-mono text-4 break-all text-[#f87171]">
              {error.message}
            </p>
          </div>
        )}
        <div className="flex gap-3 justify-center">
          <button
            onClick={reset}
            className="px-5 py-2.5 rounded-16 text-3.5 font-medium bg-bg-muted text-fg-default border border-solid border-border-default"
          >
            Try Again
          </button>
          <button
            onClick={() => window.location.reload()}
            className="px-5 py-2.5 rounded-16 text-3.5 font-medium bg-accent-primary text-[white]"
          >
            Refresh Page
          </button>
        </div>
      </div>
    </div>
  );
}
